import tubiao from "../../static/pic/图表.svg"
import {Action} from "../../util/interfaceData"
import loadingImg from "../../static/pic/页面加载.gif"
import error from "../../static/pic/error.png"
import {isProduction} from "../../function/checkProduct"
const initialState = {
    viewType: "operate_test",
    url: "#",
    billid: -1,
    fileSizeMax: 0,
    model: null,
    hasUpload: true,
    uploadOrDisplay: "upload",
    progress: "",
    uploadFileList: [],
    claData: {
        claFileInfos: [],
        claRecoginzeDatas: [],
    },
    activeIndex: 0,
    activeImageId: 0,
    status: "idle", // idle,loading,error,display
    templateName: "",
    recognitionArea: [],
    errorField: [],
    table: [],
    jsonData: {},
    markdownName: "",
    errorMessage: "",
    showPic: tubiao,
    showTip: "请上传分类文件",
    pageLabel: "result", // result md json
}

export function modelTestReducer(state = initialState, action: Action) {
    isProduction ? console.log("...state") : null
    isProduction ? console.log(action) : null
    isProduction ? console.log("_______________________________") : null

    switch (action.type) {
        case "modelTestInit":
            return {
                ...initialState,
            }
        case "classiferInit":
            return {
                ...state,
                ...action.payload,
            }
        case "classiferUpdate":
            if (state.billid === action.payload.billid) {
                return {
                    ...state,
                    status: "success",
                    activeIndex: 0,
                    activeImageId: 0,
                    claData: action.payload.claData,
                }
            } else {
                return {
                    ...state,
                }
            }
        case "setActiveIndexAndImageId":
            return {
                ...state,
                activeIndex: action.payload.activeIndex,
                activeImageId: action.payload.imageId,
            }
        case "setModel":
            return {
                ...state,
                model: action.payload,
            }
        case "setPageLabe":
            return {
                ...state,
                pageLabel: action.payload,
            }
        case "setJson":
            return {
                ...state,
                json: action.payload,
            }
        case "loading":
            return {
                ...initialState,
                status: "loading",
                showPic: loadingImg,
                showTip: "识别中......",
            }
        case "stopLoading":
            return {
                ...initialState,
                status: "error",
                showPic: error,
                showTip: "上传失败，请上传格式正确的图片",
            }
        case "modelTestUpdate":
            return {
                ...state,
                ...action.payload,
            }
        case "setTipsAndPics":
            return {
                ...state,
                showPic: action.payload.pic,
                showTip: action.payload.tip,
            }
        case "uploadFile":
            return {
                ...state,
                uploadFileList: state.uploadFileList.concat(action.payload),
            }
        case "clearUploadFileList":
            return {
                ...state,
                uploadFileList: [],
            }
        case "startTesting":
            return {
                ...state,
                uploadOrDisplay: "display",
                status: "loading",
            }
        case "uploadFileMultiple":
            return {
                ...state,
                uploadFileList: state.uploadFileList.concat(action.payload),
            }
        default:
            return state
    }
}
